import Loyalty from '~/client/features/Loyalty';
import useAgentData from '~/client/hooks/useAgentData';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import FavouriteToggle from './FavouriteToggle';
import GameTitle from './GameTitle';

const GameHeader: FC = () => {
  const isLoggedIn = useIsLoggedIn();
  const { isDesktop } = useAgentData();

  return (
    <div className="flex h-16 w-full items-center justify-between">
      <div className="inline-container gap-2">
        {isLoggedIn && <FavouriteToggle />}
        <GameTitle />
      </div>
      {isDesktop && <Loyalty module="game" />}
    </div>
  );
};

export default GameHeader;
